<template>
  <filter-template
    @submit="proxyFilter()"
  >
    <form-group class="mt-6 pa-0">
      <v-row>
        <v-checkbox
          id="importadoSgv"
          v-model="payload.importadoSgv"
          label="Importado do SGV"
        />
      </v-row>
      <v-row class="mt-6">
        <v-col cols="12">
          <span>Data de nascimento</span>
          <v-row class="mt-1">
            <v-col cols="6">
              <input-date
                id="minBirthDate"
                v-model="payload.minBirthDate"
                label="Data inicial"
              />
            </v-col>
            <v-col cols="6">
              <input-date
                id="maxBirthDate"
                v-model="payload.maxBirthDate"
                label="Data final"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </form-group>
  </filter-template>
</template>

<script>
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import usersStatusEnum from '@/app/arch/enums/usersStatusEnum';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';
import UF from '@/app/arch/enums/UF';

export default {
  name: 'NotificationUserFilter',
  components: { FilterTemplate, FormGroup },
  mixins: [FilterMixin],
  data: () => ({
    payload: {
      minBirthDate: '',
      maxBirthDate: '',
      importadoSgv: '',
    },
    states: UF,
    radioOptions: [
      {
        value: false,
        label: 'Não',
        color: 'primary',
      },
      {
        value: true,
        label: 'Sim',
      },
    ],
    status: usersStatusEnum,
  }),
  computed: {
    handleFilters() {
      return (filters) => this.handleNotificationFilters(filters);
    },
  },
  created() {
    this.setFilters();
  },
  methods: {
    preparePayload() {
      return {
        ...this.payload,
        status: this.payload.status && this.payload.status.length ? `${
          this.payload.status.map((_, i) => i)
        }` : this.payload.status,
      };
    },
    prepareQuery(query) {
      return {
        ...query,
        status: query && query.status ? query.status.split(',')
          .map((i) => this.status[i]) : [],
      };
    },
    proxyFilter() {
      this.filter();
      this.$nextTick(
        () => {
          this.handleFilters(
            this.payload,
          );
        },
      );
    },
    setFilters() {
      this.$root.$on('set-notifications-filters', (filters) => {
        if (filters) {
          if (typeof filters === 'object') {
            this.payload = this.prepareFilters(filters);
            this.$nextTick(() => {
              this.proxyFilter();
            });
          }
        }
      });
    },
    prepareFilters(filters) {
      return Object.keys(filters)
        .map(
          (key) => {
            const prop = key.split('')
              .map(
                (char, i) => {
                  if (i === 0) {
                    return char.toLowerCase();
                  }
                  return char;
                },
              ).join('');
            return {
              [prop]: filters[key],
            };
          },
        ).reduce(
          (obj, crr) => ({ ...obj, ...crr }),
          {},
        );
    },
  },
  inject: {
    handleNotificationFilters: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
